import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Divider from '@mui/material/Divider';

import Sidebar from './Sidebar';

const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        // Padding condicional - menor quando drawer fechado
        padding: open ? theme.spacing(0) : theme.spacing(1, 2),
        transition: theme.transitions.create(['margin', 'padding'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create(['margin', 'padding'], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

const Layout = () => {
    const theme = useTheme();
    const [open, setOpen] = useState(true); // Começa com a sidebar aberta

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >
                <DrawerHeader>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                <Sidebar />
            </Drawer>
            <Main open={open}>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    sx={{
                        // Posicionamento quando drawer fechado
                        ...(!open && { 
                            position: 'absolute',
                            top: 8,
                            left: 15,
                            zIndex: theme.zIndex.fab,
                            backgroundColor: theme.palette.primary.main,
                            color: 'white',
                            minWidth: '40px',
                            height: '40px',
                            '&:hover': {
                                backgroundColor: theme.palette.primary.dark,
                            }
                        }),
                        ...(open && { display: 'none' }),
                    }}
                >
                    <MenuIcon />
                </IconButton>
                
                {/* Container do conteúdo principal */}
                <Box sx={{
                    paddingTop: open ? '10px' : '40px', // Espaço para o header/botão
                    paddingLeft: open ? 1 : 1, // Padding mínimo em ambos os casos
                    paddingRight: open ? 1 : 1,
                    paddingBottom: open ? 1 : 1,
                    minHeight: 'calc(100vh - 64px)',
                }}>
                    <Outlet />
                </Box>
            </Main>
        </Box>
    );
};

export default Layout;